<template lang="html">

  <div class="selector-anio row-start" v-if="aniosAcademicos.length > 0">
    <label for="anio-academico" :style="styles.colorBasic">{{ $t('anio_academico') }}:</label>
    <select id="anio-academico" :value="anioAcademico" @change="cambiar($event.target.value)">
      <option :value="anio.id" v-for="anio in aniosAcademicos" :key="anio.id">{{ anio.descripcion }}</option>
    </select>
  </div>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'selector-anio',
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      aniosAcademicos: 'getAniosAcademicos',
      anioAcademico: 'getAnioAcademico'
    })
  },
  methods: {
    ...mapActions(['cambiarAnioAcademico']),
    cambiar(idAnioAcademico) {
      if (idAnioAcademico != this.anioAcademico) {
        this.cambiarAnioAcademico(idAnioAcademico);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.selector-anio {
  align-items: center;
  margin-top: 5px;

  label {
    font-size: 16px;
    font-weight: bold;
    margin-right: 10px;
    white-space: nowrap;
  }

  select {
    font-size: 14px;
    padding: 2px 5px;
    border: none;
    border-bottom: 1px solid #d8d8d8;
    background-color: none;
    color: #003865;
    cursor: pointer;
    outline: none;
    padding-right: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/selector-anio.vue